export const RISK_PROMPT_EXAMPLES: string[] = [
  'Show me all high-risk appointments this week',
  "Which patients haven't confirmed for tomorrow?",
  'How many critical no-show risks this month?',
  'Flag all unconfirmed high-risk appointments for outreach',
  'Resend the reminder for the 2pm appointment on Thursday',
];
